export default __webpack_public_path__ + "static/media/gaseousDeliveryLearnMore.da1cbbd4.png";